import React from 'react';
export var ControlError = function (_a) {
    var error = _a.error, touched = _a.touched;
    return touched && error ? React.createElement("div", { className: 'ErrorText' }, error) : (null);
};
//# sourceMappingURL=ControlError.js.map